var _path, _path2, _path3, _rect, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoupe = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M97 55.5C97 76.2107 80.2107 93 59.5 93C38.7893 93 22 76.2107 22 55.5C22.0232 34.7989 38.7989 18.0232 59.5 18C80.2107 18 97 34.7893 97 55.5Z",
    fill: "#37607E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 55.7162C8 27.1541 31.148 4 59.7024 4C88.2569 4 111.405 27.1541 111.405 55.7162C111.405 67.739 107.303 78.8036 100.423 87.5864L121.115 108.284C122.322 109.49 123 111.127 123 112.834C123 114.54 122.323 116.177 121.116 117.384L117.385 121.116C114.873 123.628 110.801 123.628 108.288 121.116L86.8911 99.7126C78.9921 104.607 69.6771 107.432 59.7024 107.432C31.148 107.432 8 84.2782 8 55.7162ZM59.7024 92.9155C80.2416 92.9155 96.8919 76.2608 96.8919 55.7162C96.8919 35.1715 80.2416 18.5168 59.7024 18.5168C39.1728 18.5398 22.536 35.1811 22.513 55.7162C22.513 76.2608 39.1633 92.9155 59.7024 92.9155Z",
    fill: "#E7ECF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2 38.4666H51.8386C52.7037 38.4666 53.5267 38.84 54.0964 39.491L56.7 42.4666H74.2C75.8568 42.4666 77.2 43.8097 77.2 45.4666V69.4666C77.2 71.1234 75.8568 72.4666 74.2 72.4666H42.2C40.5431 72.4666 39.2 71.1234 39.2 69.4666V41.4666C39.2 39.8097 40.5431 38.4666 42.2 38.4666ZM43.2 45.4666C41.5431 45.4666 40.2 46.8097 40.2 48.4666V68.4666C40.2 70.1234 41.5431 71.4666 43.2 71.4666H73.2C74.8568 71.4666 76.2 70.1234 76.2 68.4666V48.4666C76.2 46.8097 74.8568 45.4666 73.2 45.4666H43.2Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.2,
    y: 47.4666,
    width: 42,
    height: 25,
    rx: 3,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M40.2 67.9666C40.2 67.1381 40.8715 66.4666 41.7 66.4666H74.7C75.5284 66.4666 76.2 67.1381 76.2 67.9666C76.2 68.795 75.5284 69.4666 74.7 69.4666H41.7C40.8715 69.4666 40.2 68.795 40.2 67.9666Z",
    fill: "#37607E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.2926 68.195C84.293 70.4621 83.3335 72.6234 81.6518 74.1439V73.7286C81.6513 71.5446 80.0722 69.681 77.918 69.3218C78.3048 68.9106 78.5207 68.3676 78.5217 67.803V66.7277C78.5212 65.4932 77.5203 64.4926 76.2857 64.4926H76.1875C74.9526 64.4926 73.9516 65.4937 73.9516 66.7285V67.8047C73.9525 68.3684 74.1677 68.9108 74.5536 69.3218C72.4056 69.6867 70.8337 71.5473 70.8327 73.7261V74.1415C69.1528 72.621 68.1946 70.4608 68.1951 68.195C68.1951 63.7498 71.7986 60.1462 76.2438 60.1462C80.6891 60.1462 84.2926 63.7498 84.2926 68.195Z",
    fill: "#A3B1BE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.918 69.3219C78.3048 68.9107 78.5207 68.3677 78.5216 67.8031V66.7278C78.5212 65.4933 77.5203 64.4927 76.2857 64.4927H76.1875C74.9526 64.4927 73.9515 65.4937 73.9515 66.7286V67.8047C73.9525 68.3685 74.1677 68.9109 74.5536 69.3219C72.4056 69.6868 70.8336 71.5474 70.8326 73.7262V74.1416C73.8942 76.9411 78.5862 76.9411 81.6478 74.1416V73.7262C81.6464 71.5445 80.0697 69.6827 77.918 69.3219Z",
    fill: "#E0E5E9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoupe);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/loupe.2409fd4fc24594a02c18e200b999e886.svg";